import React from 'react';
import { motion } from 'framer-motion';
import { Utensils, Move, Heart } from 'lucide-react';
export function Protocol333Section() {
  const pillars = [{
    icon: <Utensils className="w-8 h-8 text-white" data-id="element-217" />,
    title: '3 Comidas Simples',
    desc: 'Sin contar calorías. Recetas anti-inflamatorias que nutren y calman tu intestino.',
    color: 'bg-sage-400'
  }, {
    icon: <Move className="w-8 h-8 text-white" data-id="element-218" />,
    title: '3 Movimientos Somáticos',
    desc: 'Ejercicios suaves de 5 minutos para liberar la tensión física acumulada en el abdomen.',
    color: 'bg-beige-400'
  }, {
    icon: <Heart className="w-8 h-8 text-white" data-id="element-219" />,
    title: '3 Hábitos Anti-Cortisol',
    desc: "Pequeños rituales diarios que le dicen a tu sistema nervioso: 'estás a salvo'.",
    color: 'bg-rose-400'
  }];
  return <section className="py-24 bg-white" data-id="element-220">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-222">
          <span className="text-sage-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-223">
            USARAS
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-6" data-id="element-224">
            El Protocolo 3-3-3
          </h2>
          <p className="text-xl text-charcoal-light" data-id="element-225">
            Un sistema simple diseñado para mujeres ocupadas. Sin gimnasio. Sin
            pasar hambre. Solo 21 días de reconexión.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-226">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative group" data-id="element-227">
              <div className="absolute inset-0 bg-cream-100 rounded-3xl transform transition-transform group-hover:scale-105 group-hover:-rotate-1" data-id="element-228"></div>
              <div className="relative bg-white border border-beige-100 p-8 rounded-3xl shadow-sm h-full flex flex-col text-center transition-transform group-hover:-translate-y-2 pt-[20px] pb-[20px] pl-[20px] pr-[20px] items-start justify-start" data-id="element-229">
                <div className={`w-20 h-20 ${pillar.color} rounded-2xl rotate-3 flex items-center justify-center mb-6 shadow-md`} data-id="element-230">
                  <div className="-rotate-3" data-id="element-231">{pillar.icon}</div>
                </div>
                <h3 className="text-2xl font-serif font-bold text-charcoal mb-4" data-id="element-232">
                  {pillar.title}
                </h3>
                <p className="text-charcoal-light leading-relaxed" data-id="element-233">
                  {pillar.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-20 text-center" data-id="element-234">
          <div className="inline-block bg-sage-50 rounded-full px-8 py-4 border border-sage-200" data-id="element-235">
            <p className="text-sage-800 font-medium text-lg" data-id="element-236">
              ✨ Resultado: Desactivación del Cortisol + Vientre Plano Natural
            </p>
          </div>
        </div>
      </div>
    </section>;
}